import { ComponentBread, ComponentHeader, StyledCreateLg } from "@components";
import {
  PATH_DEPO_RECORDS,
  PATH_INVENTORY_CREATE,
  PATH_INVENTORY_MASTER,
  PATH_PRODUCT_CREATE,
  PATH_PRODUCT_MASTER,
} from "@configs";
import { IInventory } from "@interfaces";

import { setLoading } from "@redux";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router";
import { InventoryForm } from "@modules";

export const PageCreateInventory = () => {
  const { id } = useParams<{ id: string }>();
  const history = useHistory();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [inventory, setInventory] = useState<IInventory>();
  useEffect(() => {
    if (id) {
      fetchProduct();
    }
  }, [id]);
  const data = [
    {
      title: <a href={PATH_INVENTORY_MASTER || ""}>{t("page.inventory_master")}</a>,
    },
    {
      title: <a href={PATH_INVENTORY_CREATE || ""}>{t("page.inventory_create")}</a>,
    },
  ];
  const fetchProduct = async () => {
    try {
      dispatch(setLoading(true));
      await console.log("here fetc");
      //   const res = await healthApi.detail(id);
      //   setProduct(res.data);
    } catch (err: any) {
      history.push(PATH_DEPO_RECORDS);
      dispatch(setLoading(false));
    } finally {
      dispatch(setLoading(false));
    }
  };

  return (
    <>
      <ComponentHeader title={t("page.add_new_product")} />
      <StyledCreateLg>
        <ComponentBread pages={data} />
        <InventoryForm inventory={inventory} />
      </StyledCreateLg>
    </>
  );
};
